import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const customers = [{
  name: 'María',
  city: 'Ciudad de México'
}, {
  name: 'Carmen',
  city: 'Guadalajara'
}, {
  name: 'Laura',
  city: 'Monterrey'
}, {
  name: 'Ana',
  city: 'Puebla'
}, {
  name: 'Sofia',
  city: 'Querétaro'
}, {
  name: 'Isabella',
  city: 'Tijuana'
}, {
  name: 'Valentina',
  city: 'León'
}, {
  name: 'Camila',
  city: 'Mérida'
}, {
  name: 'Daniela',
  city: 'San Luis Potosí'
}, {
  name: 'Gabriela',
  city: 'Aguascalientes'
}];
export function SalesNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentCustomer, setCurrentCustomer] = useState(customers[0]);
  useEffect(() => {
    const showNotification = () => {
      // Randomize customer
      const randomCustomer = customers[Math.floor(Math.random() * customers.length)];
      setCurrentCustomer(randomCustomer);
      setIsVisible(true);
      // Hide after 3 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 3000);
    };
    // Initial delay before first notification
    const initialDelay = setTimeout(() => {
      showNotification();
    }, 2000);
    // Repeat every 6 seconds (3s visible + 3s hidden)
    const interval = setInterval(() => {
      showNotification();
    }, 6000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-1">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 100,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1]
    }} className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 md:hidden" data-id="element-2">
          <div className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-lg border border-gray-200/50 p-3 flex items-center gap-3 max-w-[340px] mx-4" data-id="element-3">
            {/* Product Image */}
            <div className="flex-shrink-0" data-id="element-4">
              <img src="https://cdn.magicpatterns.com/uploads/psxnRS9vbKE6pXZXLY9tSH/No_es_gordura,_es_inflamacion.png" alt="Producto" className="w-12 h-12 rounded-lg object-cover" data-id="element-5" />
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-6">
              <p className="text-sm font-medium text-gray-900 leading-tight" data-id="element-7">
                {currentCustomer.name} de {currentCustomer.city}
              </p>
              <p className="text-xs text-gray-600 mt-0.5" data-id="element-8">
                acaba de comprar{' '}
                <span className="font-semibold" data-id="element-9">
                  No es Gordura, es Inflamación
                </span>
              </p>
              <p className="text-xs font-semibold text-[var(--color-coral)] mt-1" data-id="element-10">
                $9.97 USD
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}